module.exports = __webpack_public_path__ + "img/desktop_contact_bg.093cb2a0.jpg";